import React, { Suspense } from 'react'
import { useSelector } from 'react-redux'
import {
	Route,
	Routes
} from 'react-router-dom'
import Dashboard from '../../containers/Home/Dashboard/Dashboard'
import News from '../../containers/News'
import NewsItem from '../../containers/News/NewsItem'
import { getIsManager } from '../../redux/selectors'
import { getCoreRoutes } from '../shared/coreRoutes'
import { getAuthRoutes } from '../shared/authRoutes'
import { getCommonRoutes } from '../shared/commonRoutes'
import SmartRedirect from "components/SmartRedirect/SmartRedirect"
import RouteChunkFallback from '../shared/RouteChunkFallback'
import { SandboxAccessGate } from 'components/SandboxAccess'
import { SANDBOX_FEATURE } from 'helpers/sandboxAccess'
import {
	LazyAddons,
	LazyAddEPRReporting,
	LazyAddNewsItem,
	LazyAddStore,
	LazyAddTransactionsForEpr,
	LazyCheckout,
	LazyDueDates,
	LazyEPRReporting,
	LazyNews,
	LazyNewsItem,
	LazyReports,
	LazyStores,
	LazySubscription,
	LazyTaxSettings,
	LazyThreshold,
	LazyTransactionsForEpr,
} from '../shared/heavyRouteChunks'

const RoutesForEPR = ({
	isLogged,
	isLoggingIn
}) => {
	const state = useSelector((state) => state)
	const IS_MANAGER = getIsManager(state)
	const openProjectName = state.user.openProjectName
	// Use shared routes instead of duplicating
	const commonRoutes = getCommonRoutes()
	const notLoggedInRoutes = getAuthRoutes(isLoggingIn)

	const loggedInRoutes = (<>
		{getCoreRoutes()}
		<Route
				path='/epr-reporting'
				element={<LazyEPRReporting />}
		/>
		<Route
				path='/epr-reporting/add'
				element={<LazyAddEPRReporting />}
		/>
		{/*<Route path="/epr-reporting/add" element={<AddEprReportingRebuild />} />*/}
		<Route
				path='/epr-reporting/add/:id/:countryId/:year/:reportType'
				element={<LazyAddEPRReporting />}
		/>
		<Route
				path='/home'
				element={<Dashboard />}
		/>
		<Route
				path='/'
				element={<Dashboard />}
		/>
		<Route
				path='/home/news'
				element={<LazyNews />}
		/>
		<Route
				path='/home/news/:newsId'
				element={<LazyNewsItem />}
		/>
		{IS_MANAGER && (<Route
				path='/home/add-news'
				element={<LazyAddNewsItem />}
		/>)}
		<Route
				path='/home/due-dates'
				element={<LazyDueDates />}
		/>
		<Route
				path='/home/threshold'
				element={<LazyThreshold />}
		/>

		<Route
				path='/transactions'
				element={<LazyTransactionsForEpr />}
		/>
		<Route
				path='/transactions/import'
				element={<LazyAddTransactionsForEpr />}
		/>
		<Route
				path='/stores'
				element={<LazyStores openProjectName={openProjectName} />}
		/>
		<Route
				path='/stores/add'
				element={<LazyAddStore openProjectName={openProjectName} />}
		/>
		<Route
				path='/reports'
				element={
					<SandboxAccessGate feature={SANDBOX_FEATURE.REPORTS}>
						<LazyReports />
					</SandboxAccessGate>
				}
		/>
		<Route
				path='/settings'
				element={<LazyTaxSettings />}
		/>
		<Route
				path='/integrations'
				element={<LazyStores openProjectName={openProjectName} />}
		/>
		<Route
				path='/integrations/add'
				element={<LazyAddStore openProjectName={openProjectName} />}
		/>

		<Route
				path='/subscription'
				element={<LazySubscription />}
		/>
		<Route
				path='/subscription/checkout'
				element={
					<SandboxAccessGate feature={SANDBOX_FEATURE.PAYMENT_MUTATIONS}>
						<LazyCheckout />
					</SandboxAccessGate>
				}
		/>
		<Route
				path='/addons'
				element={
					<SandboxAccessGate feature={SANDBOX_FEATURE.PAYMENT_MUTATIONS}>
						<LazyAddons />
					</SandboxAccessGate>
				}
		/>

		{/* Payment success routes */}
		<Route
				path='/payments/subscription_bin_success/'
				element={<SmartRedirect />}
		/>
		<Route
				path='/api/payments/subscription_bin_success/'
				element={<SmartRedirect />}
		/>

		<Route
				path='*'
				element={<SmartRedirect />}
		/>
	</>)

	return (<Suspense fallback={<RouteChunkFallback />}>
		<Routes >
			{commonRoutes}
			{isLogged ? loggedInRoutes : notLoggedInRoutes}
		</Routes >
	</Suspense>)
}

export default RoutesForEPR
